module.exports = __webpack_public_path__ + "img/login_head.b9eb729b.png";